import { ConfigTypeOverride } from '@cp/shared/config';
import { token } from '@cp/shared/di';
import { ConfigManager } from 'src/shared/config';

export const RUNTIME_CONFIG_CONTAINER_ID = 'urn:x-youhelp:runtime-config';
export const CONFIG_MANAGER_TOKEN = token<ConfigManager<ConfigTypeOverride>>('ConfigManager');
